export const translation = {
  navigateToPaymentMethods: 'Autres façons de payer',
  payWithCard: 'Payer par carte',
  cardNumber: 'Nº de carte',
  cardExpiry: "Date d'expiration (MM/AA)",
  cardExpiryPlaceholder: 'MM/AA',
  cardCVV: 'Cryptogramme visuel',
  cardholderName: 'Nom du titulaire de la carte',
  cardholderNamePlaceholder: 'Nom complet',
  digits: 'chiffres',
  previouslyUsed: 'Précédemment utilisé:',
  forgetPaymentMethods: 'Supprimer les méthodes de paiement',
  forgetSavedCard: 'Supprimer la carte se terminant par {{last4Digits}}',
  required: 'Obligatoire',
  invalid: 'Invalide',
  cardInvalid: "Le numéro de carte n'est pas valide",
  expiryInvalid: "La date d'expiration n'est pas valide",
  expiryMonthInvalid: "Le mois de la date d'expiration n'est pas valide",
  expiryYearInvalid: "L'année de la date d'expiration n'est pas valide",
  cardExpired: 'La carte a expiré',
  cardIncomplete: 'Le numéro de carte est incomplet',
  expiryIncomplete: "La date d'expiration est incomplète",
  cvvIncomplete: 'Le numéro CVV est incomplet',
  cvvInvalid3: 'CVV doit être composé de 3 chiffres',
  cvvInvalid4: 'CVV doit être composé de 4 chiffres',
  cardRequired: 'Le numéro de carte est requis',
  expiryRequired: "La date d'expiration est requise",
  cvvRequired: 'Le numéro CVV est requis',
  cardNameRequired: 'Le nom sur la carte est requis',
  forgetPayPal: 'Supprimer le compte PayPal',
  savePaymentMethod: 'Enregistrer le mode de paiement',
  managePaymentMethods: 'Gérez vos modes de paiement',
  savedPaymentMethodsEmpty:
    'Entrez les détails de votre carte ci-dessous pour ajouter un nouveau mode de paiement',
  newPaymentMethod: 'Ajouter un nouveau mode de paiement',
  cardEndingWith: 'Carte finissant par',
  otherWaysToPay: 'Autres moyens de paiement',
  pay: 'Payez',
  addCard: 'Ajouter carte',
  // Payment methods dropdown
  editPaymentMethods: 'Modifier les modes de paiement sauvegardés',
  confirmCardDeletion: 'Confirmer - Supprimer Carte',
  confirmPayPalDeletion: 'Confirmer - Supprimer PayPal',
  delete: 'Supprimer',
  cancel: 'Annuler',
  confirm: 'Confirmer',

  // Direct Debit Form
  accountHolder: 'Titulaire du Compte',
  address: 'Adresse',
  addressLine1: 'Adresse ligne 1',
  addressLine2: 'Adresse ligne 2',
  fullName: 'Nom et prénom',
  email: 'Email',
  city: 'Ville',
  postalCode: 'Code Postal',
  setUpDirectDebit: 'Configurer Direct Debit',
  unsupportedCardType: 'Type de carte non pris en charge',
  // Direct Debit success
  directDebitSuccessTitle: 'Le prélèvement automatique a bien été configuré',
  directDebitSuccessDescription: `{{companyName}} apparaîtra sur votre relevé bancaire à chaque fois qu'un prélèvement automatique sera effectué`,
  directDebitSuccessReference: 'Référence',
  // Direct Debit Mandate
  directDebitMandateTitle: 'Mandat de prélèvement automatique SEPA',
  // Success scene
  checkSuccessTitle: 'Votre paiement a été effectué avec succès !',
  // Error
  tokenizationError:
    "Votre paiement n'a pas pu être traité. Veuillez essayer avec un autre mode de paiement.",
  duplicatePaymentMethodError: 'Ce moyen de payment est déjà enregistré.',
  // Payment Method Popup Overlay
  paymentMethodPopupOverlayClose: 'Fermer',
  paymentMethodPopupOverlayDescription:
    "Un problème pour retrouver l'interface de paiement de {{paymentMethodName}} ? Nous allons vous aider à la retrouver !",
  paymentMethodPopupOverlayBringBackThePaymentPage:
    "Afficher l'interface de paiement",
};
